const PurchasedItems = (items, orderNumber, userPhone, GUID) => {
    if (!window.eS) return;

    const generalInfo = {};
    if (window.phone) generalInfo.user_phone = window.phone;
    if (window.email) generalInfo.user_email = window.email;
    if (userPhone || window.phone) generalInfo.externalCustomerId = userPhone || window.phone;
    
    const products = Object.keys(items).map(key => ({
        productKey: String(items[key].options.parent_product.sku),
        price: String(items[key].options.parent_product.price),
        quantity: String(items[key].qty),
        currency: 'UAH'
    }))
    
    window.eS('sendEvent', 'PurchasedItems', {
        "OrderNumber": String(orderNumber),
        'PurchasedItems': [
            // {
            // "productKey": "24-MB02",
            // "price": "153",
            // "quantity": "1",
            // "currency": "UAH"
            // },
            ...products
        ],
        // 'GUID': '2b914e9c-43ee-bf41-6f80-b97db1e8ab7e'
        ...GUID,
        'GeneralInfo': {
            ...generalInfo
        },
     });
     
}

export default PurchasedItems;